import {NextPage} from 'next';

import {withBasicDataServerSide} from 'core/next/controllers';
import {stockXController} from 'modules/stock-x/controller';
import {StockXPageProvider} from 'modules/stock-x/provider/StockXPageProvider';
import {StockXPageContent} from 'modules/stock-x/pages';
import {TGetListingTransformedResponse} from 'plugins/modules/listing/types';
import {IProductShort} from 'modules/products/types';
import {TGetListingRequest} from 'plugins/modules/listing/api/api';

interface IProps {
    pageProps: {
        data: TGetListingTransformedResponse<IProductShort>;
        initialArgs: TGetListingRequest<{section?: string; tabId?: string}>;
    };
}

const StockPage: NextPage<IProps> = ({pageProps}) => {
    const {initialArgs, data} = pageProps;

    return (
        <StockXPageProvider initialData={data} initialArgs={initialArgs}>
            <StockXPageContent />
        </StockXPageProvider>
    );
};

export const getServerSideProps = withBasicDataServerSide(async (store, ctx) => {
    const {data, initialArgs} = await stockXController(store, ctx);

    return {
        props: {
            initialArgs,
            data,
        },
    };
});

export default StockPage;
